import { ROUTE_EARLY_ACCESS } from '@/constants/routes';
import setTitleFromLoader from '@/utils/routing/set-title';
import { RouteObject } from 'react-router-dom';
import Page from './early-access.page';

export const routeEarlyAccess: RouteObject = {
  path: ROUTE_EARLY_ACCESS,
  Component: Page,
  loader: setTitleFromLoader('Early Access'),
};
